export enum ProductValidationErrorsEnum {
  MINIMUM_AMOUNT_BY_BRAND = "MINIMUM_AMOUNT_BY_BRAND",
  FRACTIONATION_AMOUNT_INVALID = "FRACTIONATION_AMOUNT_INVALID"
}
